import { createContext, useContext, useEffect, useState } from "react";

import type { UnsignedCookie } from "@cerbos/spitfire-shared/cookie";

import type { InitialState, State } from "~/utils/state";
import { initialize } from "~/utils/state";

const cookiesContext = createContext<Record<string, string>>({});

export const CookiesProvider = cookiesContext.Provider;

export function useCookie<Data>(
  cookie: UnsignedCookie<Data>,
  initialState: InitialState<Data>,
): State<Data>;

export function useCookie<Data>(
  cookie: UnsignedCookie<Data>,
  initialState?: InitialState<Data | null>,
): State<Data | null>;

export function useCookie<Data>(
  cookie: UnsignedCookie<Data>,
  initialState: InitialState<Data | null> = null,
): State<Data | null> {
  const cookies = useContext(cookiesContext);

  const [data, setData] = useState(
    () => cookie.parse(cookies) ?? initialize(initialState),
  );

  useEffect(() => {
    document.cookie = cookie.serialize(data);
  }, [cookie, data]);

  return [data, setData];
}
